import { endpoint } from "views/pages/manage/common/constant";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const fetchDropdowns = async () => {
  return await fetchAllPromisedData(endpoint?.concessionReversalMaster?.dropdowns);
};

export const fetchConcessionList = async () => {
  return await fetchAllPromisedData(endpoint?.concessionReversalMaster?.create, true);
};

export const createConcession = async (body) => {
  return await fetchAllPostPromisedData(endpoint?.concessionReversalMaster?.create, body, "post");
};

export const updateConcession = async (id, body) => {
  return await fetchAllPostPromisedData(`${endpoint.concessionReversalMaster.create}`, body, "put");
};

export const toggleConcessionStatus = async (id, body) => {
  return await fetchAllPostPromisedData(`${endpoint.concessionReversalMaster.update}`, body, "put");
};

export const getAuditLogs = async (id) => {
    const slg = `${id}?type=concessionReversal`;
    return await fetchAllPromisedData(`${endpoint.concessionReversalMaster.getLogs}/${slg}`, true);
  };